import { lazy } from 'react';

const NotFoundPageConfig = {
  settings: {
    layout: {
      style: 'layoutFull',
      config: {}
    }
  },
  routes: [
    {
      path: '/404-not-found',
      component: lazy(() => import('./not-found-page')),
      title: 'Sayfa Bulunamadı 404'
    }
  ]
};

export default NotFoundPageConfig;
